<template>
  <a-drawer v-if="showDrawer"
            :width="500"
            placement="right"
            @close="closeDrawer"
            :visible="showDrawer">

    <h3>Admin User Form - {{formTypeHeader}}</h3>

    <a-spin :spinning="spinning">

      <base-alert v-if="errMsgs.length" type="danger">
        <b>You have the following error(s):</b>
        <li v-for="error in errMsgs" :key="error">{{ error }}</li>
      </base-alert>

      <div class="row form-cont">
        <base-input alternative=""
                    label="Last Name"
                    placeholder=""
                    v-model="lastName"
                    input-classes="form-control"
                    required/>

        <base-input alternative=""
                    label="First Name"
                    placeholder=""
                    v-model="firstName"
                    input-classes="form-control"
                    required/>

        <base-input class='mb-0'
                    alternative=""
                    label="Username"
                    placeholder=""
                    v-model="username"
                    input-classes="form-control"
                    required/>

        <base-input class='mt-3 mb-0'
                    alternative=""
                    label="Email"
                    placeholder=""
                    v-model="email"
                    input-classes="form-control"
                    required/>

        <b-form-text v-if='action == "edit"' class='password-note'>
          Note: Fill password and confirm password if you want to update Admin user's password
        </b-form-text>

        <base-input class="mt-3 mb-0"
                    aria-describedby="password-help"
                    alternative=""
                    label="Password"
                    placeholder=""
                    type="password"
                    v-model="password"
                    input-classes="form-control"
                    required/>

        <b-form-text id="password-help">
          Limited to 8-15 alphanumeric with special characters only
        </b-form-text>

        <base-input class="mt-3"
                    alternative=""
                    label="Confirm Password"
                    placeholder=""
                    type="password"
                    v-model="confirmPassword"
                    input-classes="form-control"
                    required/>

        <p class="h4 form-control-label">
          Status of Admin User
          <a-switch class='float-right'
                    @change="switchToggle"
                    :checked="userStatus == 'A'"
                    style="margin-bottom:5px"/>
        </p>
      </div>

    </a-spin>

    <div class="button-cont">
      <button type="button"
              class="btn btn-primary float-right"
              @click.prevent="sendRequest"
              :disabled="spinning">
        Apply
      </button>

      <button type="button"
              class="btn btn-danger float-right mr-2"
              @click="closeDrawer"
              :disabled="spinning">
        Close
      </button>
    </div>
  </a-drawer>
</template>

<script>
import { mapState } from 'vuex';
import HTTPRequest from '../../../controllers/httpRequest.js'
import secureStorage from "../../../controllers/secureStorage.js";
import ValidateField from '../../../components/validateFormUtils.js';

export default {
  data() {
    return {
      errMsgs: [],
      formTypeHeader: 'Create',
      spinning: false,
      userPasswordFormatStrict: false,
      firstName: '',
      lastName: '',
      username: '',
      email: '',
      password: null,
      confirmPassword: null,
      userStatus: 'I',
    }
  },
  props: {
    user: Object,
    showDrawer: Boolean,
    action: String,
  },
  computed: {
    ...mapState(['endPoint']),
  },
  mounted: function() {
    if (this.action == 'edit') {
      this.formTypeHeader = `Edit ${this.user.name}`;
    }
  },
  watch: {
    showDrawer() {
      this.errMsgs = [];
      this.firstName = this.user.first_name || '';
      this.lastName = this.user.last_name || '';
      this.username = this.user.user_name || '';
      this.email = this.user.email || '';
      this.userStatus = this.user.status || 'I';
      this.password = null;
      this.confirmPassword = null;

      if (this.action == 'edit') {
        this.formTypeHeader = `Edit ${this.user.name}`;
      } else {
        this.formTypeHeader = `Create`;
      }
    }
  },
  methods: {
    closeDrawer() {
      this.$emit('closeDrawer', false)
    },
    switchToggle(checked){
      this.userStatus = checked ? 'A' : 'I'
    },
    validate() {
      let errors = [];
      const nameRegex = /^[a-z0-9 ñ-]+$/i;
      const usernameRegex = /^[a-z0-9ñ_]+$/i;
      const passwordRegex = /^[a-zA-Z0-9!?@]+$/i;

      if (this.firstName.trim().length == 0) {
        errors.push("First name can't be blank.")
      } else if (this.firstName.match(nameRegex) == null) {
        errors.push('First name must only contain alphanumeric characters, spaces ( ) and dash (-).')
      }


      if (this.lastName.trim().length == 0) {
        errors.push("Last name can't be blank.")
      } else if (this.lastName.match(nameRegex) == null) {
        errors.push('Last name must only contain alphanumeric characters, spaces ( ) and dash (-).')
      }

      if (this.username.trim().length == 0) {
        errors.push("Username can't be blank.")
      } else if (this.username.match(usernameRegex) == null) {
        errors.push('Username must only contain alphanumeric characters and underscore (_).')
      }

      if (this.email.trim().length == 0) {
        errors.push('Email must not be blank.')
      } else {
        const validateEmailMsg = ValidateField.emailFormat('Email', this.email)

        if (validateEmailMsg) {
          errors.push(validateEmailMsg);
        }
      }

      const password = this.password || '';
      const confirmPassword = this.confirmPassword || '';

      if (this.action == 'create' || (password.length > 0 || confirmPassword.length > 0)) {
        if (password.trim().length == 0) {
          errors.push("Password can't be blank.")
        }

        if (confirmPassword.trim().length == 0) {
          errors.push("Confirm Password can't be blank.")
        }

        if (password.trim().length > 0) {
          if (password.match(passwordRegex) == null) {
            errors.push('Password must only contain Alphanumeric and any of the following special characters: !?@')
          }
          else if (password.length < 8) {
            errors.push('Password must contain at least 8 characters')
          }
          else if (password != confirmPassword) {
            errors.push('Password and Confirm Password does not match')
          }
        }
      }

      this.errMsgs = errors;

      return errors.length == 0
    },
    sendRequest: async function() {
      this.spinning = true;

      if (!this.validate()) {
        this.spinning = false;
        return;
      }

      let request = {};
      let url = `${this.endPoint}admin`;

      let payload = {
        user: {
          id: this.user.id || null,
          first_name: this.firstName,
          last_name: this.lastName,
          user_name: this.username,
          email: this.email,
          status: this.userStatus,
          password: this.password,
          confirm_password: this.confirmPassword
        }
      }

      if (this.action == 'edit') {
        url = `${url}/${this.user.id}`;
        request = await HTTPRequest.putRequest(url, null, payload);
      } else {
        request = await HTTPRequest.postRequest(url, null, payload);
      }

      if (request.error) {
        if (Array.isArray(request.error)) {
          this.errMsgs = request.error;
        } else {
          const errors = request.error.split(',');
          this.errMsgs = errors;
        }

        this.spinning = false;
      } else {
        let desc = this.action == 'create' ? 'Admin user was created' : 'Admin user was updated';

        this.$notification['success']({
          message: 'Save Success',
          description: desc
        });

        this.spinning = false;
        this.$emit('success')

        const userId = secureStorage.getItem("userId");

        if (parseInt(userId) == request.id) {
          this.$router.go();
        }
      }

    }
  }
}
</script>

<style scoped>
.form-cont {
  display: flex;
  flex-flow: column;
  padding: 10px 20px;
}

.button-cont {
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: -webkit-fill-available;
  background-color: #f2f2f2;
  padding: 10px;
}

.password-note {
  color: #525f7f !important;
  font-size: 14px;
  font-weight: bold;
  margin-top: 20px;
}
</style>
